export default __webpack_public_path__ + "static/media/Vehicle-Attributes.50651da0.jpg";